var _style, _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLexisNexisRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    id: "svg82",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style10"
  }, "\n.st1{fill:#e8171f;}\n        .st2{fill:#231f20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(-18.62 -14.275)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.8 37.7c1.8-3.6 4.7-6.4 8.2-8.1.4-.2.8-.4 1.2-.5V29c-12.3 2.1-17.6 17.4-9.4 24 0 0 .1 0 0 0-1.1-1.7-4-7.3 0-15.3z",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.6 47.9c-.3-2-.3-4.1 0-6.1.6-4 2.6-7.6 5.3-10.3.5-.5 1.1-1 1.6-1.4V30c-6.5 2.9-10.2 10.1-9.7 16.6.3 3 1.4 8.5 7.2 9.6 0 0 .1 0 0-.1-2.3-1.5-4-5.3-4.4-8.2z",
    id: "path17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.3 27c-4.4-1.4-9-.5-11.8 1.8-1.2 1-2.1 2.7-2.9 4.3 0 0 0 .1.1 0 2.8-4 8.8-6.8 14.6-6.1z",
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.2 38.2c-.8-9.3-9.2-16.4-18.5-15.5-3.2.3-6.7 1.6-9.3 3.8v.1c2.2-1.3 5.3-1.2 7.1-1 .9.1 1.9.3 2.8.6.9.3 1.8.6 2.6 1.1.4.2.9.5 1.3.7 1.5-.7 3.1-1.1 4.8-1.4.1 0 .2 0 .3.2.1.1 0 .3-.2.3-.9.2-1.7.4-2.6.7v.1c1.2 0 2.4.1 3.5.4.1 0 .2.1.2.2 0 .2-.1.3-.3.3-1-.2-2-.2-3-.2v.1c.5.1.9.3 1.4.5.9.4 1.7.8 2.5 1.3.1 0 .1.1.1.2 0 .2-.2.3-.4.2-.8-.4-1.6-.8-2.5-1.1-.4-.1-.7-.2-1.1-.3 0 0-.1 0 0 .1.6.4 1.2.8 1.7 1.2.7.6 1.4 1.3 2 2 .1.1.1.2 0 .2-.1.2-.3.2-.4.1-.6-.7-1.3-1.3-2-1.8-.4-.3-.9-.6-1.3-.9 0 0-.1 0 0 .1l.4.4c.6.7 1.2 1.5 1.6 2.3.5.8.9 1.6 1.2 2.5v.2c-.1.1-.3.1-.4-.1-.3-.8-.7-1.6-1.2-2.4-.5-.8-1-1.5-1.6-2.1-.6-.7-1.3-1.3-2-1.8-.2-.2-.5-.4-.6-.4-14 7.8-9.2 28.4 1 27.3 8-2.1 13.6-9.7 12.9-18.2z",
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8 35.7c3.2-5.1 8.9-7.3 12.3-7.7v-.1c-1.4-.1-2.7 0-4.5.3-1.7.4-3.4 1.1-4.9 2.1-1.5 1-2.8 2.2-3.9 3.6-2.1 2.8-2.8 6.4-1.9 9.8.1.4.4 1.2.5 1.7h.1c-.5-3.9.6-7.1 2.3-9.7z",
    id: "path23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.18 14.025c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5c0-.9-.7-1.5-1.5-1.5zm0 2.7c-.7 0-1.2-.6-1.2-1.3 0-.7.6-1.3 1.2-1.3.7 0 1.2.6 1.2 1.3.1.8-.5 1.3-1.2 1.3z",
    id: "path55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.78 15.125c0-.3-.2-.5-.6-.5h-.6v1.7h.3v-.7h.3l.4.7h.3l-.4-.7c.2-.1.3-.3.3-.5zm-.6.2h-.3v-.5h.3c.2 0 .3.1.3.2.1.3 0 .3-.3.3z",
    id: "path57"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexisNexisRed);
export default __webpack_public_path__ + "static/media/LexisNexisRed.3aff79ed4a266bfb65fce8f16d8ae64c.svg";
export { ForwardRef as ReactComponent };